const findBiggestShade = (palette) => Math.max.apply(null, Object.keys(palette).map(Number));

export default findBiggestShade;
